<script setup lang="ts">
type Variant = 'primary' | 'secondary' | 'danger' | 'outlined' | 'text' | 'warning'

withDefaults(
  defineProps<{
    variant?: Variant
    type?: 'button' | 'submit' | 'reset'
    loading?: boolean
    disabled?: boolean
  }>(),
  {
    variant: 'primary',
    type: 'button',
    loading: false,
    disabled: false,
  },
)
</script>

<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    :class="[
      'inline-flex items-center justify-center whitespace-nowrap h-10 px-4 rounded-xl text-sm font-semibold transition-colors',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      variant === 'primary' && 'bg-[#0588ff] text-white shadow-[0_8px_20px_-10px_rgba(5,136,255,0.45)] hover:bg-[#0474d9]',
      variant === 'secondary' && 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900',
      variant === 'danger' && 'bg-[#D12637] text-white hover:bg-[#b01f2e]',
      variant === 'outlined' && 'border border-brand-500 text-brand-500 hover:bg-brand-50',
      variant === 'text' && 'text-brand-500 hover:bg-brand-50',
      // Amber — thao tác mật khẩu/cảnh báo nhẹ (khớp nút reset-password ở Corp/TenantCorpAdmin).
      variant === 'warning' && 'bg-amber-50 text-amber-700 hover:bg-amber-100 hover:text-amber-800',
    ]"
  >
    <svg
      v-if="loading"
      class="animate-spin -ml-1 mr-2 h-4 w-4 opacity-90"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
    <slot />
  </button>
</template>
